var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wa-chat-header",
      class: { "wa-chat-header--mobile": _vm.mobileMode },
    },
    [
      _vm.mobileMode
        ? _c(
            "button",
            {
              staticClass: "wa-chat-header__back-btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("back")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "22",
                    height: "22",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M15 18l-6-6 6-6",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wa-chat-header__contact",
          on: {
            click: function ($event) {
              return _vm.$emit("view-contact")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "wa-chat-header__avatar", style: _vm.avatarStyle },
            [
              _vm.avatarUrl && !_vm.avatarError
                ? _c("img", {
                    staticClass: "wa-chat-header__avatar-img",
                    attrs: { src: _vm.avatarUrl, alt: "" },
                    on: {
                      error: function ($event) {
                        _vm.avatarError = true
                      },
                    },
                  })
                : _c(
                    "span",
                    { staticClass: "wa-chat-header__avatar-initials" },
                    [_vm._v(_vm._s(_vm.initials))]
                  ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wa-chat-header__info" }, [
            _c("div", { staticClass: "wa-chat-header__name" }, [
              _vm._v(_vm._s(_vm.displayName)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wa-chat-header__subtitle" }, [
              _vm.phoneNumber && _vm.phoneNumber !== _vm.displayName
                ? _c("span", { staticClass: "wa-chat-header__phone" }, [
                    _vm._v(_vm._s(_vm.phoneNumber)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.channelLabel
                ? _c(
                    "span",
                    {
                      staticClass: "wa-chat-header__channel-badge",
                      class: _vm.channelBadgeClass,
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.channelLabel) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.contact.lastConversation &&
              _vm.contact.lastConversation.status === "destroyed"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "wa-chat-header__status wa-chat-header__status--closed",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("whatsappUi.statusClosed")) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm.contact.lastConversation
                ? _c(
                    "span",
                    {
                      staticClass:
                        "wa-chat-header__status wa-chat-header__status--open",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("whatsappUi.statusOpen")) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wa-chat-header__actions" },
        [
          _vm.showWaba24hWarning
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: _vm.$t("whatsappUi.waba24hWindowTooltip"),
                      },
                      expression:
                        "{ content: $t('whatsappUi.waba24hWindowTooltip') }",
                    },
                  ],
                  staticClass: "wa-chat-header__waba-warning",
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        width: "16",
                        height: "16",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
                          fill: "#e67e22",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("whatsappUi.waba24hExpiredBadge"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isWabaChannel
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: _vm.$t("whatsappUi.templateMessageTooltip"),
                      },
                      expression:
                        "{ content: $t('whatsappUi.templateMessageTooltip') }",
                    },
                  ],
                  staticClass: "wa-chat-header__btn",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("open-template")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        width: "20",
                        height: "20",
                        fill: "none",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "3",
                          y: "3",
                          width: "18",
                          height: "18",
                          rx: "3",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M7 8h10M7 12h10M7 16h6",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("whatsappUi.searchInChatTooltip") },
                  expression:
                    "{ content: $t('whatsappUi.searchInChatTooltip') }",
                },
              ],
              staticClass: "wa-chat-header__btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("search")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "20",
                    height: "20",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M11 3a8 8 0 100 16 8 8 0 000-16zM21 21l-4.35-4.35",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("whatsappUi.contactInfoTooltip") },
                  expression:
                    "{ content: $t('whatsappUi.contactInfoTooltip') }",
                },
              ],
              staticClass: "wa-chat-header__btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("view-contact")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "20",
                    height: "20",
                    fill: "none",
                  },
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: "12",
                      cy: "8",
                      r: "3",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M5 20c0-4 3.134-7 7-7s7 3 7 7",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-dropdown",
            { attrs: { trigger: ["click"], placement: "bottomRight" } },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("whatsappUi.moreMenuTooltip") },
                      expression:
                        "{ content: $t('whatsappUi.moreMenuTooltip') }",
                    },
                  ],
                  staticClass: "wa-chat-header__btn",
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        width: "20",
                        height: "20",
                        fill: "none",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "12",
                          cy: "5",
                          r: "1.5",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "12",
                          cy: "12",
                          r: "1.5",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "12",
                          cy: "19",
                          r: "1.5",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-menu",
                { attrs: { slot: "overlay" }, slot: "overlay" },
                [
                  _c(
                    "a-menu-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("view-contact")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("whatsappUi.menuContactInfo")))]
                  ),
                  _vm._v(" "),
                  _vm.contact.lastConversation &&
                  _vm.contact.lastConversation.status !== "destroyed"
                    ? _c(
                        "a-menu-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close-conversation")
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("whatsappUi.menuCloseConversation"))
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }